// Listener dipasang sekali per elemen (ditandai di dataset) supaya pemanggilan
// berulang helperFilter() tidak menumpuk handler scroll.
const hide = (id) => {
    const el = document.getElementById(id);
    if (el) el.style.display = 'none';
};

const hideOverlays = () => {
    hide('luckysheet-dataVerification-dropdown-List');
    hide('luckysheet-input-box');
    hide('luckysheet-input-box-index');
    hide('arrowCanvas-overshow');
    hide('luckysheet-postil-overshow-style-fiki');
};

let stickyColumns = 0;

// Ikon filter kolom beku dibuat menempel di kiri saat scroll horizontal.
// Posisi dasar disimpan per elemen; kalau Luckysheet menulis ulang `left`
// (render ulang), nilai itu dianggap posisi dasar yang baru.
const syncFilterIcons = (scrollLeft) => {
    const icons = document.querySelectorAll('.luckysheet-filter-options-c .luckysheet-filter-options');
    icons.forEach((icon) => {
        const cindex = parseInt(icon.getAttribute('data-cindex'), 10);
        if (!(cindex >= 0 && cindex < stickyColumns)) return;
        const current = parseFloat(icon.style.left) || 0;
        let base = current;
        if (icon.dataset.stickyLast === String(current) && icon.dataset.stickyBase !== undefined) {
            base = parseFloat(icon.dataset.stickyBase);
        } else {
            icon.dataset.stickyBase = String(current);
        }
        const next = base + scrollLeft;
        icon.style.left = next + 'px';
        icon.dataset.stickyLast = String(parseFloat(icon.style.left));
        if (scrollLeft > 0) icon.style.zIndex = '1000';
    });
};

const helperFilter = (row) => {
    stickyColumns = row;

    const containerX = document.getElementById('luckysheet-scrollbar-x');
    const containerY = document.getElementById('luckysheet-scrollbar-y');
    if (!containerX || !containerY) return;

    const inbox = document.getElementById('luckysheet-input-box');
    if (inbox && !inbox.dataset.helperFilterBound) {
        inbox.dataset.helperFilterBound = '1';
        inbox.addEventListener('mouseover', () => {
            const dropdownList = document.getElementById('luckysheet-dataVerification-dropdown-List');
            if (!dropdownList) return;
            const leftPosition = getComputedStyle(inbox).getPropertyValue('left');
            setTimeout(() => {
                dropdownList.style.position = 'absolute';
                dropdownList.style.left = (parseInt(leftPosition, 10) + containerX.scrollLeft - 44) + 'px';
            }, 50);
        });
    }

    let frame = 0;
    const onScroll = (type) => {
        if (type === 'y') {
            const btn = document.getElementById('luckysheet-dataVerification-dropdown-btn');
            if (btn) btn.style.setProperty('display', 'none', 'important');
        }
        if (frame) return;
        frame = requestAnimationFrame(() => {
            frame = 0;
            const scrollLeft = containerX.scrollLeft;
            hideOverlays();
            const freezen3 = document.getElementById('freezen_3');
            if (freezen3) freezen3.style.zIndex = scrollLeft > 0 ? '20' : '10';
            const freezen7 = document.getElementById('freezen_7');
            if (freezen7) freezen7.style.overflowX = 'auto';
            syncFilterIcons(scrollLeft);
        });
    };

    if (!containerX.dataset.helperFilterBound) {
        containerX.dataset.helperFilterBound = '1';
        containerX.addEventListener('scroll', () => onScroll('x'));
    }
    if (!containerY.dataset.helperFilterBound) {
        containerY.dataset.helperFilterBound = '1';
        containerY.addEventListener('scroll', () => onScroll('y'));
    }
};

export default helperFilter;
